import { TransferInput } from '../../lib/types/models/transfer/transfer-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateTransfer(data: UpdateInput<TransferInput>) {
  const { id, ...rest } = data
  return restApiClient.url(constructApiUrl(API.transfer.update.url, { id })).patch(rest)
}
